import * as Sentry from "@sentry/react";
import { ENV } from "./env";

Sentry.init({
  dsn: ENV.SENTRY_DSN, // empty string disables Sentry
  sendDefaultPii: true,
  environment: ENV.SENTRY_ENVIRONMENT
});
